import { http } from '../../core/services/http';

export const loadZipCodes = (zipCode: string) =>
  http
    .get(`/common/zipCodeSearch`, {
      params: { zipCode },
    })
    .then(response => response.data);
